import EmptyActiveVehiclePlaceholder from './EmptyActiveVehiclePlaceholder'

export default EmptyActiveVehiclePlaceholder
